﻿const $ = require("jquery");

// css theme imports
require("jquery-ui/themes/base/accordion.css")
require("jquery-ui/themes/base/all.css")
require("jquery-ui/themes/base/autocomplete.css")
require("jquery-ui/themes/base/base.css")
require("jquery-ui/themes/base/button.css")
require("jquery-ui/themes/base/checkboxradio.css")
require("jquery-ui/themes/base/controlgroup.css")
require("jquery-ui/themes/base/core.css")
require("jquery-ui/themes/base/datepicker.css")
require("jquery-ui/themes/base/dialog.css")
require("jquery-ui/themes/base/draggable.css")
require("jquery-ui/themes/base/menu.css")
require("jquery-ui/themes/base/progressbar.css")
require("jquery-ui/themes/base/resizable.css")
require("jquery-ui/themes/base/selectable.css")
require("jquery-ui/themes/base/selectmenu.css")
require("jquery-ui/themes/base/slider.css")
require("jquery-ui/themes/base/sortable.css")
require("jquery-ui/themes/base/spinner.css")
require("jquery-ui/themes/base/tabs.css")
require("jquery-ui/themes/base/theme.css")
require("jquery-ui/themes/base/tooltip.css")

// js imports
$.accordion = require("jquery-ui/ui/widgets/accordion");
$.autocomplete = require("jquery-ui/ui/widgets/autocomplete");
$.button = require("jquery-ui/ui/widgets/button");
$.checkboxradio = require("jquery-ui/ui/widgets/checkboxradio");
$.controlgroup = require("jquery-ui/ui/widgets/controlgroup");
$.datepicker = require("jquery-ui/ui/widgets/datepicker");
$.dialog = require("jquery-ui/ui/widgets/dialog");
$.draggable = require("jquery-ui/ui/widgets/draggable");
$.droppable = require("jquery-ui/ui/widgets/droppable");
$.menu = require("jquery-ui/ui/widgets/menu");
$.mouse = require("jquery-ui/ui/widgets/mouse");
$.progressbar = require("jquery-ui/ui/widgets/progressbar");
$.resizable = require("jquery-ui/ui/widgets/resizable");
$.selectable = require("jquery-ui/ui/widgets/selectable");
$.selectmenu = require("jquery-ui/ui/widgets/selectmenu");
$.slider = require("jquery-ui/ui/widgets/slider");
$.sortable = require("jquery-ui/ui/widgets/sortable");
$.spinner = require("jquery-ui/ui/widgets/spinner");
$.tabs = require("jquery-ui/ui/widgets/tabs");
$.tooltip = require("jquery-ui/ui/widgets/tooltip");

window.$ = window.jQuery = $;